import { computed, inject, Injectable } from '@angular/core';
import {
  RsOverviewServerSideStateManager
} from '@rs-shared-lib/abstract-classes/rs-overview-state/rs-overview-server-side-state-manager';
import {
  RsPersistOverviewState
} from '@rs-shared-lib/abstract-classes/rs-overview-state/persistency/rs-persist-overview-state.decorator';
import { rsCountFilters } from '@rs-shared-lib/utils/count-filters/count-filters';
import {
  GetCancelledTransactionsRequestParams,
  TransactionItemResponse,
  TransactionsService
} from '@api-client/mobipay';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@app/shared/constants';

@RsPersistOverviewState('TransactionsCancelled')
@Injectable({
  providedIn: 'root',
})
export class CancelledStateService extends RsOverviewServerSideStateManager<
  TransactionItemResponse,
  GetCancelledTransactionsRequestParams
> {
  public readonly filterCount = computed(() =>
    rsCountFilters(this.filters(), [
      'source',
      ['cancelDateFrom', 'cancelDateTo'],
      ['deliveryDateFrom', 'deliveryDateTo'],
      'sellerSite',
      'sellerCompany',
      'buyerCompany',
    ]),
  );

  private readonly transactionsService = inject(TransactionsService);
  constructor() {
    super({
      serviceMethod: (params) =>
        this.transactionsService.getCancelledTransactions(params as GetCancelledTransactionsRequestParams, 'response'),
      initialPagination: { pageIndex: 0, pageSize: 15 },
      config: {
        pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
      },
    });
  }
}

